angular.module('offlineChecker')
    .controller('Login', Login);

Login.$inject = ['sessionFactory', 'uiManagerFactory', 'loginFactory', 'storageFactory'];

function Login(sessionFactory, uiManagerFactory, loginFactory, storageFactory) {
    var vm = this;
    vm.session = sessionFactory;
    vm.uiManager = uiManagerFactory;
    vm.login = loginFactory;
    vm.storage = storageFactory;
    vm.clearPin = clearPin;
    vm.cancelPinLogin = cancelPinLogin;
    vm.clearUsername = clearUsername;
    vm.clearPassword = clearPassword;
    vm.setUserToLogin = setUserToLogin;
    vm.newUserLogin = newUserLogin;
    vm.knownUserLogin = knownUserLogin;
    vm.resetLogin = resetLogin;

    vm.clearNewPin = clearNewPin;
    vm.clearConfirmNewPin = clearConfirmNewPin;
    vm.registerNewPin = registerNewPin;
    vm.cancelNewPin = cancelNewPin;
    vm.populateAvailableUsers = populateAvailableUsers;
    vm.uiManager.logoutable = false;

    // alerts
    vm.initialLoginMessage = true;
    vm.newPinMessage = true;
    vm.newUserLoginError = false;
    vm.userNotAuthorised = false;

    vm.existingPin = {
        errors: ''
    };
    // reset user account details - this is used to log users out of the system
    resetLoginForm();
    vm.populateAvailableUsers();

    /////////////////////////

    function clearPin() {
        vm.session.currentLogin.pin = '';
    }

    function cancelPinLogin() {
        vm.session.currentLogin.pin = '';
        vm.session.currentLogin.username = '';
        vm.session.currentLogin.user = null;
        vm.existingPin.errors = '';
    }

    function clearUsername() {
        vm.session.currentLogin.username = '';
    }

    function clearPassword() {
        vm.session.currentLogin.password = '';
    }

    function newUserLogin() {
        vm.uiManager.loader.isFullScreenLoading = true;
        vm.login.username = vm.session.currentLogin.username;
        vm.login.password = vm.session.currentLogin.password;
        vm.login.login(registerSuccessLogin, registerFailedLogin);
    }

    function knownUserLogin() {
        vm.uiManager.loader.isFullScreenLoading = true;
        // populate the user details based on the pin entered
        vm.session.currentLogin.username = vm.session.currentLogin.user.username;
        var userToken = '';
        // grab the token
        try {
            userToken = vm.storage.userToken.get(vm.session.currentLogin.pin);
            vm.existingPin.errors = ''; // clear any previous error messages
            vm.session.selectedProperty = vm.storage.selectedProperty.get(vm.session.currentLogin.pin);
            vm.session.changingProperty = false;
            vm.session.tempSelectedProperty = vm.session.selectedProperty;
            vm.login.syncKnownUser(userToken, successKnownSync, failedKnownSync);
        }catch(ex){
            vm.existingPin.errors = 'incorrect pin';
            vm.session.currentLogin.pin = "";
            vm.uiManager.loader.isFullScreenLoading = false;
            return false;
        }
    }

    function successKnownSync(data){
        vm.session.currentLogin.validated = true;
        successfulSync(data);
    }

    function failedKnownSync(data)
    {
        // grab the data from localstorage
        vm.session.savedReservations = vm.storage.reservations.get(vm.session.currentLogin.pin);
        vm.session.savedKeys = vm.storage.keys.get(vm.session.currentLogin.pin);
        vm.session.properties = vm.storage.properties.get(vm.session.currentLogin.pin);
        vm.session.savedUnitReportGroups = vm.storage.savedUnitReportGroups.get(vm.session.currentLogin.pin);
        vm.session.selectedProperty = vm.storage.selectedProperty.get(vm.session.currentLogin.pin);
        vm.session.lastSynced = vm.storage.lastSynced.get(vm.session.currentLogin.pin);
        vm.session.changingProperty = false;
        vm.session.currentLogin.validated = true;
        vm.session.currentLogin.user = vm.session.availableUsers[0];
        vm.uiManager.goToPage('/search');
    }

    function resetLogin() {
        vm.session.currentLogin = vm.session.setBlankCurrentLogin();
    }

    function registerSuccessLogin(data, status, headers, config) {
        vm.uiManager.loader.isFullScreenLoading = false;
        vm.uiManager.loginManager.askUserForNewPin = true;
        // clear any previous fail login message:
        vm.newUserLoginError = false;
        // clear any previously user property selection
        vm.session.selectedProperty = null;
        vm.session.changingProperty = true;
        vm.session.tempSelectedProperty = null;
    }

    function registerNewPin() {
        vm.uiManager.loader.isFullScreenLoading = true;
        if (vm.login.newPin.first !== vm.login.newPin.confirm) {
            vm.login.newPin.errors = "pin doesn't match";
            vm.uiManager.loader.isFullScreenLoading = false;
            vm.clearNewPin();
            vm.clearConfirmNewPin();
            return;
        }
        if (isNaN(vm.login.newPin.first)) {
            vm.login.newPin.errors = "pin isn't strictly numbers";
            vm.uiManager.loader.isFullScreenLoading = false;
            vm.clearNewPin();
            vm.clearConfirmNewPin();
            return;
        }
        if (vm.login.newPin.first.length !== 5) {
            vm.login.newPin.errors = "pin isn't 5 numbers long";
            vm.uiManager.loader.isFullScreenLoading = false;
            vm.clearNewPin();
            vm.clearConfirmNewPin();
            return;
        }
        // update the user as being valid - for logout button to show
        vm.session.currentLogin.validated = true;
        vm.session.currentLogin.user = vm.login.username;
        vm.session.currentLogin.pin = vm.login.newPin.confirm;
        // sync with the server
        vm.login.sync(successfulSync, failedSync);
    }

    function clearNewPin() {
        vm.login.newPin.first = '';
    }

    function clearConfirmNewPin() {
        vm.login.newPin.confirm = '';
    }

    function cancelNewPin() {
        resetLoginForm();
    }

    function populateAvailableUsers() {
        vm.session.availableUsers = vm.storage.savedUser.get();
    }

    function successfulSync(data) {
        try {
            // set the records
            vm.session.savedKeys = data.data.keys;
            vm.session.savedReservations = data.data.data;
            vm.session.userAttachedAccount = data.data.user.pid;
            vm.session.name = data.data.user.firstName + ' ' + data.data.user.lastName;
            vm.session.savedProperties = data.data.properties;
            vm.session.savedUnitReportGroups = data.data.unitReportGroups;
            try {
                vm.session.selectedProperty = vm.storage.selectedProperty.get(vm.session.currentLogin.pin);
            } catch(Exception){
                vm.session.selectedProperty = null;
            }
            vm.session.lastSynced = moment().toDate();
            // save the records
            // check if the available users are not already in the array
            var tempUser = {
                name: vm.session.name,
                username: vm.session.currentLogin.username
            };
            vm.session.availableUsers = [tempUser];
            vm.storage.savedUser.set(vm.session.availableUsers);
            vm.storage.userToken.set(data.data.token, vm.session.currentLogin.pin);
            vm.storage.reservations.set(vm.session.savedReservations, vm.session.currentLogin.pin);
            vm.storage.keys.set(vm.session.savedKeys, vm.session.currentLogin.pin);
            vm.storage.properties.set(vm.session.savedProperties, vm.session.currentLogin.pin);
            vm.storage.savedUnitReportGroups.set(vm.session.savedUnitReportGroups, vm.session.currentLogin.pin);
            vm.storage.lastSynced.set(vm.session.lastSynced, vm.session.currentLogin.pin);
            // check the users property list
            if(data.data.properties.length === 1) {
                vm.session.selectedProperty = data.data.properties[0].id;
                vm.session.changingProperty = false;
            }
            vm.storage.selectedProperty.set(vm.session.selectedProperty, vm.session.currentLogin.pin);
            // move the user to the search screen
            // hide the loader
            vm.uiManager.goToPage('/search');
        } catch(exception){
            console.log(exception);
            resetLoginForm();
            registerFailedLogin(data);
            vm.uiManager.goToPage('/login');
        }
    }

    function failedSync(data) {
        resetLoginForm();
        registerFailedLogin(data);
        vm.uiManager.goToPage('/login');
    }

    function resetLoginForm() {
        vm.login.username = '';
        vm.login.password = '';
        vm.login.newPin.first = '';
        vm.login.newPin.confirm = '';
        vm.session.currentLogin.user = null;
        vm.session.currentLogin.validated = false;
        vm.session.currentLogin.username = '';
        vm.session.currentLogin.password = '';
        vm.session.currentLogin.pin = '';
        vm.uiManager.loginManager.askUserForNewPin = null;
    }

    function registerFailedLogin(data, status, headers, config) {
        vm.newUserLoginError = false;
        vm.userNotAuthorised = false;
        vm.initialLoginMessage = false;
        vm.newPinMessage = false;

        if(data.data && typeof data.data.syncd !== 'undefined' && !data.data.syncd){
            vm.userNotAuthorised = true;
        } else {
            // updatge error message for the login screen.
            vm.newUserLoginError = true;
        }

        // reset username and password fields.
        clearPassword();
        clearUsername();
        // hide the loader
        vm.uiManager.loader.isFullScreenLoading = false;
    }

    function setUserToLogin(userIndex) {
        // clear any previous login errors
        vm.session.currentLogin.password = '';
        vm.newUserLoginError = false;
        vm.uiManager.loginManager.askUserForNewPin = null;
        if (userIndex >= 0 && userIndex < vm.session.availableUsers.length) {
            vm.session.currentLogin.user = vm.session.availableUsers[userIndex];
        } else {
            vm.session.currentLogin.user = null;
        }
    }
}
